import { Mail, MapPin, Phone } from 'lucide-react';
import React from 'react';
import { H2, XStack, YStack, Image } from 'tamagui';

import { ContactElement, IconContainer } from './components';
import { homeServiceLogo } from '../../assets';
import { DividerLine } from '../../components/common/DividerLine';
import { StyledCard } from '../Settings_General/components/styles';

export const ServiceContactSettings: React.FC = () => {
  const location = '275 Old County Line Rd P Westerville, OH 43081';
  const phone = '(123) 456-7890';
  const email = 'contact@homeserviceco.com';
  const companyName = 'Home Service Company';

  return (
    <YStack padding="$5">
      <StyledCard height="432px">
        <XStack gap="$5" alignItems="center" justifyContent="flex-start">
          <Image source={{ uri: homeServiceLogo }} width={210} height={80} objectFit="contain" />
          <H2 color="$white12" fontSize="$6" lineHeight="$5">
            {companyName}
          </H2>
        </XStack>
        <DividerLine />
        <YStack gap="$5">
          <ContactElement
            icon={
              <IconContainer>
                <MapPin size={36} />
              </IconContainer>
            }
            value={location}
          />
          <ContactElement
            icon={
              <IconContainer>
                <Phone size={36} />
              </IconContainer>
            }
            value={phone}
          />
          <ContactElement
            icon={
              <IconContainer>
                <Mail size={36} />
              </IconContainer>
            }
            value={email}
          />
        </YStack>
      </StyledCard>
    </YStack>
  );
};
